
import React from 'react';
import { FeatureShowcase } from '@/components/subscription/FeatureShowcase';

export function LearningPathPreview() {
  const benefits = [
    "Personalized learning paths tailored to your goals",
    "Track your progress with visual indicators",
    "AI-recommended topics based on your performance",
    "Comprehensive preparation for competitive exams",
    "Structured curriculum with clear milestones",
    "Adaptive difficulty that grows with your knowledge"
  ];
  
  const screenshots = [
    {
      url: "/lovable-uploads/a7fab99d-d9bc-41e5-8828-43df93feb683.png",
      caption: "Adaptive Learning Path - Your personalized roadmap to success"
    },
    {
      url: "/lovable-uploads/fe6ceec4-a337-46f1-a902-95609e691b1e.png",
      caption: "Analytics - Comprehensive performance insights"
    },
    {
      url: "/lovable-uploads/40370903-845a-4564-b160-2a0f15129e32.png",
      caption: "Adaptive Learning - Personalized content based on your needs"
    }
  ];

  return (
    <FeatureShowcase
      title="Adaptive Learning Paths"
      description="Follow a personalized roadmap to master your study goals efficiently."
      featureName="Learning Paths"
      benefits={benefits}
      screenshots={screenshots}
    />
  );
}
